<template>
  <div class="backup-list">

    <v-container grid-list-xl fluid>
      <v-sheet
        min-height="300"
        rounded="lg"
        elevation="6"
      >

        <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
          <v-toolbar-title  class="hidden-sd-and-down">
              <h2><v-icon large class="mr-2">mdi-content-save-all</v-icon>{{$t('administration.backup.backups')}}</h2>
          </v-toolbar-title>
          <v-spacer />
          <div class="d-inline-flex">
            <v-btn
              class="ml-2"
              :disabled="userHasAccess('backup_edit') == 0"
              color="primary"
              @click="confirmBackup = true"
            >
              {{ $t('administration.backup.backupmanual')}}
            </v-btn>
          </div>
        </v-toolbar>

          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <BackupFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.date" slot-scope="{ item }">
                  {{ formatDateTime(item['date'], 'long') }}
                </template>
                <template slot="item.finished" slot-scope="{ item }">
                  {{ formatDateTime(item['finished'], 'long') }}
                </template>
                <template slot="item.success" slot-scope="{ item }">
                  <strong v-if="item.success" >
                    {{ item.success }}
                  </strong>
                  <span v-else>
                    {{ item.success }}
                  </span>
                </template>
                <template slot="item.auto" slot-scope="{ item }">
                  <span v-if="item.auto" >
                    {{ item.auto }}
                  </span>
                  <span v-else>
                    {{ item.auto }}
                  </span>
                </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>

      </v-sheet>
    </v-container>

    <Confirm
      :visible="confirmBackup"
      :handleconfirm="backupManual"
      :titreconfirm="$t('administration.backup.backupmanual')"
      :textconfirm="$t('administration.backup.confirmbackup')"
      @close="confirmBackup = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import BackupFilterForm from '../../components/backup/Filter';
import DataFilter from '../../components/DataFilter';
import AccessMixin from '../../mixins/AccessMixin';
import Confirm from '../../components/Confirm';

export default {
  name: 'BackupList',
  servicePrefix: 'Backup',
  mixins: [ListMixin,AccessMixin],
  components: {
    ActionCell,
    BackupFilterForm,
    DataFilter,
    Confirm
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.date'), value: 'date' },
        { text: this.$t('administration.backup.finished'), value: 'finished' },
        { text: this.$t('administration.backup.address'), value: 'address' },
        { text: this.$t('administration.backup.size'), value: 'size' },
        { text: this.$t('administration.backup.auto'), value: 'auto' },
        { text: this.$t('administration.backup.success'), value: 'success' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
      confirmBackup: false
    };
  },
  computed: {
    ...mapGetters('backup', {
      items: 'list'
    }),
    ...mapFields('backup', {

      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view',
      action: 'action',
      actioned: 'actioned',
    })
  },
  methods: {
    ...mapActions('backup', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    ...mapActions({
      backupPushAction: 'backup/action',
    }),
    backupManual() {
      this.backupPushAction({action: 'backupmanual',values: {}});
    },
    backuped(item) {
        console.log(item);
        item.message && this.showMessage(item.message);
        this.getPage();
    },
  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }

      if (this.action == 'backupmanual') {
        this.backuped(actioned);
      }
    },

  }
};
</script>
